// Component names
export const DUMMY_COMPONENT = 'nav-components:dummy' as const;

// Component tags
export const Tags = {
  SIDE_PANEL: 'SIDE_PANEL',
  MODAL: 'MODAL',
  BANNER: 'BANNER',
} as const;

export type Tags = typeof Tags;
export type Tag = Tags[keyof Tags];
export type TagList = ReadonlyArray<Tag>;

// Loggers
export const PLATFORM_LOGGER = 'NEST_PLATFORM_LOGGER' as const;
export const SCHEDULER_LOGGER = 'NEST_SCHEDULER_LOGGER' as const;

// Others
export const DEFAULT_PLATFORM_NAME = 'unified-navigation-ui';
